import { Component, Input } from '@angular/core';

@Component({
  selector: 'ss-widget-header',
  template: `
    <header class="ss-widget-header ss-widget-header--{{ tone }}">
      <h3 class="ss-widget-header__title">
        <span class="ss-widget-header__bar" aria-hidden="true"></span>
        {{ title }}
        <span *ngIf="count !== null" class="ss-badge">{{ count }}</span>
        <button *ngIf="help" type="button" class="ss-badge ss-badge--info" [ssTooltip]="help" [attr.aria-label]="help">i</button>
      </h3>
      <div class="ss-widget-header__actions"><ng-content></ng-content></div>
    </header>
  `,
  standalone: false
})
export class WidgetHeaderComponent {
  @Input() title = '';
  @Input() tone: 'brand' | 'info' | 'success' | 'purple' | 'teal' | 'warning' = 'brand';
  @Input() count: number | null = null;
  @Input() help = '';
}
